// pages/cards/tableConfig.js
export const tableConfig = {
  columns: [
    { label: '', value: 'name', width: '5%',  align: 'center', type: 'count' },
    { label: 'Name', value: 'name', width: 220, align: 'left',  type: 'text', search: 'name' },
    // Keep description moderate so action buttons don’t wrap
    { label: 'Description', value: 'description', width: 420, align: 'left', type: 'text', search: 'description' },
  ],

  // Server should filter by org via X-Org-Id; this endpoint mirrors your prior cards list
  queryName: '/cards/getFiltered',

  pageSize: 20,
  startNum: 1,
  pageTitle: 'Card Designs',

  // Add new card design
  onAddNew: '/cards/add',

  // Deletion (align to your existing API)
  deletePathTemplate: '/cards/deletedoc/{_id}',
  deleteMethod: 'DELETE',
};
